import Cookies from 'js-cookie';
import * as URX_FORM from '../constant/urx-form';
/**
 * hook to set cookie value for App points, answer and price range
 *
 * @returns {Object} cookie value
 */
export const useSetCookie = (
  appPoint: number,
  ans: string[],
  cookieURL: string,
  lowerPrice: string,
  higherPrice: string,
) => {
  Cookies.set(
    'urxdcq',
    JSON.stringify({
      source: URX_FORM.FORM_ID,
      dcq: {
        Q_NOTESDATA: `${cookieURL} AppPoint: ${appPoint} | ${ans.join(
          ', ',
        )} | Estimated Range: ${lowerPrice} - ${higherPrice}`,
      },
    }),
  );
};
